/* eslint complexity: ["error", 5], max-params: ["error", 4], max-depth: ["error", 2], max-statements: ["error", 10] */
var trackingUtils = require('../../modules/utils/tracking.utils');
var searchTypes = {
    O: 'oneWayTrip',
    R: 'roundTrip',
    M: 'multipleTrip',
};
var perkTypeMap = {
    CABIN_BAG: 'cabin',
    CHECKED_BAG: 'checked',
    STANDARD_SEAT_RESERVATION: 'seat',
    CHANGE_BEFORE_DEPARTURE: 'change',
    REFUND_BEFORE_DEPARTURE: 'refund',
};

var perkTypeTrackingOrder = ['CABIN_BAG', 'CHECKED_BAG', 'STANDARD_SEAT_RESERVATION', 'CHANGE_BEFORE_DEPARTURE', 'REFUND_BEFORE_DEPARTURE'];

var constrains = {
    airline: function(scope, flights) {
        return Odigeo._.every(Odigeo._.pluck(flights, 'carriercode'), Odigeo._.bind(Odigeo._.includes, _, scope.split(',')));
    },
    searchTypes: function(scope, flights, search) {
        return Odigeo._.some(scope.split(','), function(type) {
            return searchTypes[type] === Odigeo._.get(search, 'type');
        });
    },
    crossFaringRestriction: function(crossFaringForbidden, flights) {
        if (crossFaringForbidden) {
            return Odigeo._.size(Odigeo._.uniq(Odigeo._.pluck(flights, 'carriercode'))) === 1;
        }

        return true;
    },
};

const string = {
    ALWAYS: 'Always',
    EXPANDED: 'Expanded',
    OTHER_SERVICE: 'OTHER_SERVICE',
};

module.exports = Odigeo.Model.extend({
    isEmptyData: true,
    dataUrl: 'fareupgrades',
    init: function() {
        this.opts = Odigeo.Utils.parseOptions(this.widget.options);
        this.opts.perks.displayFormatted = this.opts.perks.display.split(',');
        this.opts.perks.displayOrder = ['INCLUDED', 'AVAILABLE_AT_A_CHARGE', 'NOT_OFFERED'];
        this.opts.perks.minimumVisiblePerks = 3;
    },
    url: function() {
        return Odigeo.Settings.getProperty('serviceUrlFormatter')(this.dataUrl);
    },
    update: function(data) {
        const modelData = {
            flightSelection: {
                data,
                details: Odigeo.Utils.parseJson(Odigeo.Session.get('selectedCarriers')),
            },
            search: Odigeo.Utils.parseJson(Odigeo.Session.get('searchParameters')),
        };
        this.set(modelData);

        if (this.checkScope()) {
            this.fetchFareFamilies();
        } else {
            this.emitEmptyUpgrades();
        }
    },
    fetchFareFamilies: function() {
        var flightSelection = Odigeo._.get(this.get('flightSelection'), 'data.data');

        var request = this.fetch({
            type: 'POST',
            data: JSON.stringify(flightSelection),
            contentType: 'application/json',
            timeout: Odigeo.UIElements.translations.fareFantasy.timeout,
        });

        if (this.checkScopeDisplay()) {
            request.then(Odigeo._.bind(this.onSuccess, this, request), Odigeo._.bind(this.emitEmptyUpgrades, this));
            if (!Odigeo.AB.isFareUpgradeRenderable) {
                this.emitEmptyUpgrades();
            }
        } else {
            this.emitEmptyUpgrades();
        }
    },
    onSuccess: function(response) {
        trackingUtils.trackEvent('results_list', 'open_result_farefam:all-fare:' + this.get('fareUpgrades').length);
        if (Odigeo.AB.isFareUpgradeRenderable) {
            this.processGetFareUpgrades(response);
        }
    },
    processGetFareUpgrades: function(request) {
        if (request.status !== 200 || Odigeo._.isEmpty(this.get('fareUpgrades')) || this.someFareUpgradePerkEmpty()) {
            this.emitEmptyUpgrades();
        } else {
            this.trigger('fetch:success');
        }
    },
    someFareUpgradePerkEmpty: function() {
        return Odigeo._.some(this.get('fareUpgrades'), function(fareUpgrade) {
            return Odigeo._.isEmpty(fareUpgrade.fareUpgradePerks);
        });
    },
    checkScope: function() {
        var flightDetails = Odigeo._.get(this.get('flightSelection'), 'details');
        var search = this.get('search');
        return Odigeo._.get(search, 'cabinClass') === 'TOURIST' && Odigeo._.every(this.opts.scope, Odigeo._.bind(function(scope, type) {
            return Odigeo._.isFunction(constrains[type]) ? constrains[type](scope, flightDetails, search) : false;
        }, this));
    },
    checkScopeDisplay: function() {
        var flightDetails = Odigeo._.get(this.get('flightSelection'), 'details');
        var scope = this.opts.airlineDisplay;
        return constrains.airline(scope, flightDetails);
    },
    emitEmptyUpgrades: function() {
        Odigeo.trigger(this.widget.id + ':emptyUpgrades', Odigeo._.get(this.get('flightSelection'), 'data'));
    },
    getFareItineraryKey: function() {
        return Odigeo._.get(this.get('flightSelection'), 'data.data.fareItineraryKey');
    },
    getFormattedFareUpgrades: function() {
        return Odigeo._.map(this.get('fareUpgrades'), Odigeo._.bind(function(item) {
            return Odigeo._.extend({}, item, {
                orderedPerks: Odigeo._.filter(this.getOrderedPerks(item.fareUpgradePerks), Odigeo._.bind(function(perk) {
                    return perk.fareUpgradePerkType !== 'OTHER_SERVICE' && this.hasPerkTypeTranslation(perk.fareUpgradePerkType);
                }, this)),
                filteredPerks: this.getOrderedPerks(this.getFilteredPerks(item.fareUpgradePerks)),
                areHidden: Odigeo._.some(item.fareUpgradePerks, Odigeo._.bind(function(perk) {
                    return perk.availability !== 'INCLUDED' && this.hasPerkTypeTranslation(perk.fareUpgradePerkType);
                }, this)),
                areIncluded: Odigeo._.some(item.fareUpgradePerks, Odigeo._.bind(function(perk) {
                    return perk.availability === 'INCLUDED' && this.hasPerkTypeTranslation(perk.fareUpgradePerkType);
                }, this)),
                totalPrice: item.price + this.getPrice(),
            });
        }, this));
    },
    getFilteredPerks: function(fareUpgradePerks) {
        let filteredPerks = [];
        const fareUpgradePerkByAvailability = Odigeo._.partial(this.getFareUpgradePerkByAvailability, fareUpgradePerks);
        Odigeo._.each(this.opts.perks.displayOrder, Odigeo._.bind(function(availability) {
            let alwaysVisiblePerks = Odigeo._.filter(fareUpgradePerkByAvailability(availability), Odigeo._.bind(function(perk) {
                return perk.fareUpgradePerkType !== string.OTHER_SERVICE &&
                    this.hasPerkTypeTranslation(perk.fareUpgradePerkType) &&
                    perk.visibility === string.ALWAYS;
            }, this));
            if (alwaysVisiblePerks.length < this.opts.perks.minimumVisiblePerks ) {
                let expandedOnlyPerks = Odigeo._.filter(fareUpgradePerkByAvailability(availability), Odigeo._.bind(function(perk) {
                    return perk.fareUpgradePerkType !== string.OTHER_SERVICE &&
                        this.hasPerkTypeTranslation(perk.fareUpgradePerkType) &&
                        perk.visibility === string.EXPANDED;
                }, this)).slice(0, this.opts.perks.minimumVisiblePerks - alwaysVisiblePerks.length);
                filteredPerks = filteredPerks.concat(expandedOnlyPerks);
            }
            filteredPerks = filteredPerks.concat(alwaysVisiblePerks);
        }, this));
        return filteredPerks;
    },
    getOrderedPerks: function(perks) {
        return Odigeo._.sortBy(Odigeo._.sortBy(perks, Odigeo._.bind(function(perk) {
            return this.opts.perks.displayFormatted.indexOf(perk.fareUpgradePerkType);
        }, this)), Odigeo._.bind(function(perk) {
            return this.opts.perks.displayOrder.indexOf(perk.availability);
        }, this));
    },
    getPrice: function() {
        return Odigeo._.get(this.get('flightSelection'), 'data.data.price');
    },
    getUpgradeFareTrackingParam: function getUpgradeFareTrackingParam(fareUpgradeName, fareUpgradeAmount) {
        var fareUpgrade;
        var fareUpgradePerks;
        if (fareUpgradeAmount === 0) {
            return 'standard';
        }
        fareUpgrade = Odigeo._.find(this.getFormattedFareUpgrades(), function(item) {
            return item.name === fareUpgradeName;
        }) || {};
        fareUpgradePerks = fareUpgrade.fareUpgradePerks || [];
        return this.getTrackingPerks(fareUpgradePerks);
    },
    getTrackingPerks: function getTrackingPerks(fareUpgradePerks) {
        return Odigeo._.map(perkTypeTrackingOrder, function(perkType) {
            return this.getFareUpgradePerkByType(fareUpgradePerks, perkType).availability === 'INCLUDED' ?
                this.getPerkTypeMapped(perkType) :
                'na';
        }, this)
            .join('-');
    },
    getPerkTypeMapped: function(key) {
        return Odigeo._.has(perkTypeMap, key) ? perkTypeMap[key] : key;
    },
    getFareUpgradePerkByType: function(fareUpgradePerks, perkType) {
        return Odigeo._.find(fareUpgradePerks, function(perk) {
            return perk.fareUpgradePerkType === perkType;
        }) || {};
    },
    getFareUpgradePerkByAvailability: function(fareUpgradePerks, perkAvailability) {
        return Odigeo._.filter(fareUpgradePerks, function(perk) {
            return perk.availability === perkAvailability;
        }) || {};
    },
    hasPerkTypeTranslation: function(fareUpgradePerkType) {
        return !(Odigeo._.isEmpty(Odigeo._.trim(this.getServiceTranslation(fareUpgradePerkType))));
    },
    getServiceTranslation: function(key) {
        return Odigeo._.get(this.opts.perks.translations, key, '');
    },
    getTranslation: function(key) {
        return Odigeo._.get(this.opts.translations, key, '');
    },
});
